import { createDarkTheme } from '../../utils/createDarkTheme';
import { brandWeb } from '../../global/brandColors';
export const webDarkTheme = /*#__PURE__*/createDarkTheme(brandWeb);
//# sourceMappingURL=darkTheme.js.map